angular.module('impactx.MenuDirectives').directive('ixCustomerServiceInfo', function () {
    return {
        restrict: 'E',
        templateUrl: 'shared/menu/templates/customer-service-info-menu.tmpl.html',
        controller: "CustomerServiceInfoCtrl",
        controllerAs: "customerServiceInfoCtrl"
    }
});